package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*
import org.lennycodes.hldi.constants.HLDITheme

val missionVisionCardStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .alignItems(AlignItems.Center)
            .padding(40.px)
            .backgroundColor(HLDITheme.Colors.white)
            .borderRadius(12.px)
            .textAlign(TextAlign.Center)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 4.px,
                blurRadius = 12.px,
                color = Color.rgba(0, 0, 0, 0.08f)
            )
            .transition(
                transition = com.varabyte.kobweb.compose.css.Transition.all(duration = 0.3.s, timingFunction = TransitionTimingFunction.Ease)
            )
    }
    hover {
        Modifier
            .translateY((-6).px)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 10.px,
                blurRadius = 24.px,
                color = Color.rgba(0, 0, 0, 0.12f)
            )
    }
}